export default __webpack_public_path__ + "static/media/uppdrag_gamling.c9e0efff.jpg";